import { createContext } from 'react';

import type {
  WebsocketFrame,
  WebsocketStatus,
} from '@/infrastructure/websocket';

export type RealtimeListener = (frame: WebsocketFrame) => void;

export interface RealtimeContextType {
  /**
   * What the app's single socket is doing. `idle` means there is no socket to
   * have: no session, or an environment without a transport.
   */
  status: WebsocketStatus;
  /**
   * How many times the socket has opened. It goes up on every reconnection,
   * which is a consumer's cue to re-read whatever it missed while it was down.
   */
  connectionCount: number;
  /** Registers a listener and returns the function that removes it. */
  subscribe: (listener: RealtimeListener) => () => void;
  /**
   * Opens the socket again after it gave up. The open it leads to counts as a
   * reconnection, so consumers re-read what they missed.
   */
  reconnect: () => void;
}

export const RealtimeContext = createContext<RealtimeContextType | undefined>(
  undefined,
);
